"use strict";

(function (Drupal, once) {
  Drupal.behaviors.modal = {
    attach: function attach(context, settings) {
      var body = document.body;
      var modal = context.querySelectorAll('.modal--trigger');
      if (!modal.length) {
        return;
      }
      once('modalInitProcessed', '.modal--container', context).forEach(function (modalContainer) {
        var modalContent = modalContainer.querySelector('.modal--content');
        var embed = modalContent.querySelector('.video--embed');
        var classes = {
          open: 'js-modal-is-open',
          triggered: 'js-modal-is-triggered',
          youtube: 'js-youtube-active',
          vimeo: 'js-vimeo-active'
        };
        var sizeMq = window.matchMedia('(max-width: 48rem)');

        /**
         * Initialize an image in a modal.
         * @param {element} element The element passed from the event listener.
         */
        var initModalImage = function initModalImage(element) {
          var src = element.getAttribute('data-modal-content');
          var alt = element.getAttribute('data-modal-alt-text');
          var orientation = element.getAttribute('data-media-orientation');
          modalContent.innerHTML = "<img src=\"".concat(src, "\" data-media-orientation=\"").concat(orientation, "\" alt=\"").concat(alt, "\">");

          // Set aspect ratio of image
          modalContent.querySelector('img[data-media-orientation]').addEventListener('load', function () {
            this.style.aspectRatio = this.width / this.height;
          });
        };

        /**
         * Promise to init YouTube API.
         */
        var youtubeApiReady = function youtubeApiReady() {
          return new Promise(function (resolve, reject) {
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/player_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            resolve(true);
          });
        };

        /**
         * Initialize a YouTube video.
         * @param {element} element The element passed from the event listener.
         */
        var initYouTube = function initYouTube(element) {
          youtubeApiReady().then(function (isResolved) {
            if (isResolved) {
              var modalUrl = element.getAttribute('data-modal-content');
              var id;
              var playlistId;
              var player;

              // If this YouTube player is a playlist we get the playlist ID.
              if (modalUrl.includes('&list')) {
                playlistId = modalUrl.split('&list=')[1];
              } else {
                // Otherwise it is just the regular video ID.
                id = modalUrl.split('?v=')[1];
              }

              // First time YT API loads.
              window.onYouTubeIframeAPIReady = function () {
                // We load the playlist if there's a playlist ID in the URL.
                if (modalUrl.includes('&list')) {
                  player = new YT.Player(embed, {
                    width: '1920',
                    height: '1080',
                    playerVars: {
                      listType: 'playlist',
                      list: playlistId
                    },
                    events: {
                      onReady: onPlayerReady
                    }
                  });
                } else {
                  // Otherwise we load the single video by the ID.
                  player = new YT.Player(embed, {
                    width: "1920",
                    height: "1080",
                    videoId: id,
                    events: {
                      onReady: onPlayerReady
                    }
                  });
                }
              };
              var onPlayerReady = function onPlayerReady(event) {
                event.target.playVideo();
              };
              modalContent.classList.add(classes.youtube);

              // After the API is loaded we either switch to a different YT video or to Vimeo.
              if (typeof YT == 'undefined') {
                return;
              }
              var embedId = modalContent.querySelector('.video--embed').getAttribute('id');
              var activeYoutube = YT.get(embedId);
              var activeVimeo = modalContent.querySelector('.video--embed > iframe');
              if (activeYoutube) {
                if (modalUrl.includes('&list')) {
                  // If this is a playlist, the only way to get it to load is
                  // to destroy the existing player and recreate the playlist player.
                  activeYoutube.destroy();
                  player = new YT.Player(embed, {
                    width: '1920',
                    height: '1080',
                    playerVars: {
                      listType: 'playlist',
                      list: playlistId
                    },
                    events: {
                      onReady: onPlayerReady
                    }
                  });
                } else {
                  // If this isn't a playlist we just load the new video into the existing player.
                  activeYoutube.loadVideoById(id);
                }
                activeYoutube.playVideo();
              }
              if (activeVimeo) {
                // We've got a vimeo Video in the modal and need to clear it out.
                removeVimeo().then(function () {
                  if (modalUrl.includes('&list')) {
                    // If this is a playlist, we do our playlist loading.
                    player = new YT.Player(document.querySelector('.video--embed'), {
                      width: '1920',
                      height: '1080',
                      playerVars: {
                        listType: 'playlist',
                        list: playlistId
                      },
                      events: {
                        onReady: onPlayerReady
                      }
                    });
                  } else {
                    player = new YT.Player(document.querySelector('.video--embed'), {
                      width: '1920',
                      height: '1080',
                      videoId: id,
                      events: {
                        onReady: onPlayerReady
                      }
                    });
                  }
                });
              }
            }
          });
        };

        /**
         * Promise to init Vimeo API.
         */
        var vimeoApiReady = function vimeoApiReady() {
          return new Promise(function (resolve, reject) {
            var tag = document.createElement('script');
            tag.src = 'https://player.vimeo.com/api/player.js';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            resolve(true);
          });
        };

        /**
         * Initialize a Vimeo video.
         * @param {element} element The element passed from the event listener.
         */
        var initVimeo = function initVimeo(element) {
          vimeoApiReady().then(function (isResolved) {
            if (isResolved) {
              var url = element.getAttribute('data-modal-content');
              var activePlayer = modalContent.querySelector('.video--embed > iframe');
              var _vimeoReady = function vimeoReady() {
                if (typeof Vimeo == 'undefined') {
                  window.setTimeout(_vimeoReady, 100);
                } else {
                  var vimeoPlayer = new Vimeo.Player(modalContent.querySelector('.video--embed'), {
                    url: url,
                    autoplay: true,
                    muted: false,
                    width: 1920,
                    height: 1080
                  });
                }
              };
              if (activePlayer) {
                var newVimeoPlayer = new Vimeo.Player(activePlayer);
                newVimeoPlayer.loadVideo(url);
              }
              modalContent.classList.add(classes.vimeo);

              // Check if YouTube video exists
              if (modalContent.classList.contains(classes.youtube)) {
                removeYoutube().then(function (isResolved) {
                  if (isResolved) {
                    _vimeoReady();
                  }
                });
              } else {
                _vimeoReady();
              }
            }
          });
        };

        /**
         * Remove a Vimeo video.
         */
        var removeVimeo = function removeVimeo() {
          return new Promise(function (resolve, reject) {
            var vimeoPlayer = modalContent.querySelector('iframe');
            vimeoPlayer.remove();
            modalContent.classList.remove(classes.vimeo);
            resolve(true);
          });
        };

        /**
         * Remove a YouTube video.
         */
        var removeYoutube = function removeYoutube() {
          return new Promise(function (resolve, reject) {
            var youtubePlayer = modalContent.querySelector('.video--embed');
            var newEmbed = document.createElement('div');
            youtubePlayer.remove();
            newEmbed.classList.add('video--embed');
            modalContent.appendChild(newEmbed);
            modalContent.classList.remove(classes.youtube);
            resolve(true);
          });
        };

        /**
         * Open the modal.
         * @param {element} element The element passed from the event listener.
         */
        var openModal = function openModal(element) {
          if (!body.classList.contains(classes.open)) {
            body.classList.add(classes.open);
            Drupal.behaviors.dart_utils.body_prevent_scroll();
            switch (element.getAttribute('data-modal-type')) {
              case 'image':
                initModalImage(element);
                break;
              case 'remote_video':
                if (element.getAttribute('data-modal-content').includes('youtube')) {
                  initYouTube(element);
                }
                if (element.getAttribute('data-modal-content').includes('vimeo')) {
                  initVimeo(element);
                }
            }
          }
        };

        /**
         * Close the modal.
         */
        var closeModal = function closeModal() {
          if (body.classList.contains(classes.open)) {
            var player = context.querySelector('.modal--content .video--embed');
            body.classList.remove(classes.open);
            Drupal.behaviors.dart_utils.body_prevent_scroll_destroy();
            if (sizeMq.matches) {
              // If we're on mobile remove the manually injected iframe.
              embed.innerHTML = '';
            }
            if (player) {
              var vimeoIframe = player.querySelector('iframe');
              if (typeof Vimeo !== 'undefined' && vimeoIframe) {
                var vimeoPlayer = new Vimeo.Player(vimeoIframe);
                vimeoPlayer.pause();
              } else {
                player.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              }
            }
          }
        };

        /**
         * Initialize the mobile video.
         * @param {element} element The element passed from the video play function.
         */
        var initMobileVideo = function initMobileVideo(element) {
          // Autoplay on mobile is inconsistent, so we take the hidden inline video field and
          // push it into the modal.
          var oembed = element.querySelector('.field--name-field-media-oembed-video');
          // We have to clone the embed – otherwise it gets moved when appended
          // and no longer available for use.
          var oembedClone = oembed.cloneNode(true);
          var activeEmbed = embed.querySelector('.field--name-field-media-oembed-video');
          // We'll have an active embed if this function has already been called.
          // This swaps the embeds out.
          if (activeEmbed) {
            activeEmbed.remove();
          }
          embed.appendChild(oembedClone);
        };

        /**
         * Initialize all modal links on a page.
         */
        var initModalLinks = function initModalLinks() {
          modal.forEach(function (el) {
            // Don't initialize the modal on mobile Mixed Gallery.
            if (sizeMq.matches && el.classList.contains('mixed-gallery__item')) {
              return;
            }
            el.addEventListener('click', function (e) {
              if (!el.parentNode.classList.contains('is-dragging')) {
                openModal(el);
              }
            });
          });
        };
        initModalLinks();
        modalContainer.addEventListener('click', closeModal);
        body.addEventListener('keydown', function (e) {
          if (e.keyCode === 27) {
            closeModal();
          }
        });
      });
    }
  };
})(Drupal, once);